module.exports = __webpack_public_path__ + "img/himax.a5b1487e.png";